/**
 * Utility functions for theme processing and manipulation
 */

/**
 * Parses a comma-separated string of theme numbers into an array of valid numbers
 * @param themes - Comma-separated string of theme numbers
 * @returns Array of valid theme numbers
 */
export const parseThemeNumbers = (themes: string): number[] => {
    return themes
        .split(",")
        .map((themeNumber) => themeNumber.trim())
        .filter((themeNumber) => themeNumber !== "")
        .map((themeNumber) => Number(themeNumber))
        .filter((num) => !isNaN(num));
};

/**
 * Validates if themes string contains valid theme numbers when storefront ID is provided
 * @param themes - Comma-separated string of theme numbers
 * @param hasExistingStorefrontId - Whether an existing storefront ID is provided
 * @returns Boolean indicating if themes are valid
 */
export const areThemesValid = (themes: string, hasExistingStorefrontId: boolean): boolean => {
    if (!hasExistingStorefrontId) {
        return true;
    }

    const themeNumbers = parseThemeNumbers(themes);
    return themeNumbers.length > 0;
};
